<!-- Confirmation d'une action qui supprime ou coupe quelque chose : une feuille
     comme les autres (titre commun, croix), la question, ce qui sera perdu,
     puis l'action en pleine largeur et « Annuler » juste dessous. -->
<vw-toast-popup [isOpen]="isOpen" [title]="title" (close)="cancelled.emit()">
  <div class="flex flex-col gap-6 px-4 pb-6">
    @if (message) {
      <p class="text-body text-vw-body" data-testid="confirm-message">{{ message }}</p>
    }
    @if (error) {
      <p role="alert" class="-mt-2 text-body-s text-vw-danger" data-testid="confirm-error">{{ error }}</p>
    }
    <div class="flex flex-col gap-2">
      <vw-button [look]="danger ? 'danger' : 'primary'" [label]="confirmLabel" [loading]="loading"
        customClass="w-full" data-testid="confirm-yes" (onClick)="confirmed.emit()"></vw-button>
      <vw-button look="quiet" [label]="cancelLabel || 'common.cancel'" [disabled]="loading"
        customClass="w-full" data-testid="confirm-no" (onClick)="cancelled.emit()"></vw-button>
    </div>
  </div>
</vw-toast-popup>
